import React, { useEffect, useState } from 'react';
import IntroImage from 'assets/images/intro.png';
import './styles.scss';
import { handleApiError } from 'utils/functions';
import { apiService } from 'utils/api';

const KitchenStatsPageOne = () => {
  const [completedOrders, setCompletedOrders] = useState<string>();
  const [previousOrders, setPreviousOrders] = useState<string>();

  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await apiService.get<{
        data: {
          today_completed: string;
          yesterday_completed: string;
        }[];
      }>('kitchen/orders-completed', {
        baseUrl: process.env.REACT_APP_KITCHEN_API_URL
      });
      setCompletedOrders(res.data.data?.[0]?.today_completed);
      setPreviousOrders(res.data.data?.[0]?.yesterday_completed);
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();

    const interval = setInterval(() => {
      fetchData();
    }, 300000); // Refresh every 5 minutes

    return () => clearInterval(interval);
  }, []);
  return (
    <div className='intro'>
      <h3 className='mb-6 intro_heading'>We see you all putting in work!</h3>
      <div className='max-w-[567px] flex items-center'>
        <p className='intro_subheading'>
          Hey, check out how awesome the team is doing! We&apos;ve spiced things up to make
          monitoring our efficiency a breeze. Now you can spot the rock stars who are totally
          crushing it. It&apos;s time to level up and take it to the next level of awesomeness!
        </p>
      </div>
      <div className='mt-8 intro_body'>
        <img src={IntroImage} alt='intro' />
        <div className='intro_body_card total_order_card'>
          <div className='pt-[14px] pl-[14px] pb-2'>
            <p>Completed orders</p>
            <h3>{loading ? '...' : completedOrders}</h3>
          </div>
        </div>
        <div className='intro_body_card completed_order_card'>
          <div className='pt-[14px] pl-[14px] pb-2'>
            <p>Yesterday orders</p>
            <h3>{loading ? '...' : previousOrders}</h3>
          </div>
        </div>
        {/* <div className='intro_body_card order_duration_card'>
          <div className='pt-[14px] pl-[14px] pb-2'>
            <p>Team of the month</p>
            <h3>{loading ? '...' : 'Team A'}</h3>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default KitchenStatsPageOne;
